/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * Falcon documents type dictionary
 */
export enum FalconDocumentsType {
  Assignations = 0,
  Invoices,
  InvoicesAndAssignations,
  InvoiceCorrections
}
